<template>
  <a-config-provider :theme="bigTheme">
    <div id="app">
      <router-view />
      <NotificationPanel />
    </div>
  </a-config-provider>
</template>

<script>
import { inject } from 'vue'
import NotificationPanel from './components/NotificationPanel.vue'

export default {
  name: 'App',
  components: { NotificationPanel },
  setup() {
    // 注入大尺寸主题配置
    const bigTheme = inject('antdTheme')
    return {
      bigTheme
    }
  }
}
</script>

<style>
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
}
</style>